export enum TagColor {
  RED = "red",
  YELLOW = "yellow",
  GREEN = "green",  
  GREY = "grey",
  BLUE = "blue",
  PURPLE = "purple",
  ORANGE = "orange",
  MAGENTA = "magenta",
  MAROON = "maroon",
  TEAL = "teal",
  NAVY = "navy",
  OLIVE = "olive",
};